<template>
  <div>
    <div class="btn-row" v-if="hasBtn">
      <div class="feature-btn order-btn cursor" @click="toFavourite">
        <i class="iconfont iconzu101" />常用物料快速下单
      </div>
    </div>
    <div class="template-form">
      <ItemOrderPick
        @setValue="setValue"
        :item-type="itemType"
        :has-company="true"
        @setCompany="setCompany"
      />
      <el-row class="form-item template-form-item" v-if="hasCompany">
        <el-col :span="3">上传订单模版文件</el-col>
        <el-col :span="21">
          <el-button type="primary" class="btn-grey-plain" @click="handleExport"
            >下载订单明细模板</el-button
          >
          <FileUpload
            ref="dataFileUpload"
            :upload-param="{ filePath: 'temp' }"
            show-type="text"
            @uploaded="getDataFile"
            @removed="clearDataFile"
            class="file-upload"
            :isClearFile="isClear"
          >
            <el-button class="btn-blue-plain">上传订单明细模板</el-button>
          </FileUpload>

          <!-- 是否拆单 -->
          <p style="padding-left:70px;">
            <el-checkbox @change="getSeparateOrder">拆单</el-checkbox>
            <span class="intro"
              >若选择拆单将会按照excel模板里的每一行明细生成不同的采购订单</span
            >
          </p>
        </el-col>
      </el-row>

      <ItemOrderRemark @setRemark="setRemark" />
      <ItemOrderList
        v-if="hasImport"
        :orderItemList="orderForm.detailList"
        :is-urgent="orderForm.purchaseOrder.isUrgent"
        @setDesc="setDesc"
      >
        <ItemOrderAddressList :orderAddressList="orderForm.deliveryList" />
      </ItemOrderList>
      <!-- 下单方式 -->
      <el-row class="form-item template-form-item" v-if="hasImport">
        <!-- <el-col :span="3" v-if="isPrints">下单方式</el-col>
        <el-col :span="12" v-if="isPrints">
          <div class="order-type-radio">
            <el-radio-group>
              <el-radio-group v-model="orderForm.purchaseOrder.isUrgent">
                <el-radio :label="0">
                  正常下单
                  <span class="radio-text"
                    >（即：集单模式，物料到仓后集中安排物流发运，物流运费占比10%）</span
                  >
                </el-radio>
                <el-radio :label="1">
                  加急下单
                  <span class="radio-text"
                    >（即：非集单模式，物料到仓后立即安排物流加急发运，物流运费占比13%）</span
                  >
                </el-radio>
              </el-radio-group>
            </el-radio-group>
          </div>
        </el-col> -->

        <el-col :span="3">期望收货日期</el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="orderForm.purchaseOrder.expectReceiveDate"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            clearable
            size="middle"
            class="time-picker"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <div class="primary-btn">
        <el-button
          type="primary"
          class="btn-blue-plain-hover"
          @click="handleSubmit"
          >提交</el-button
        >
      </div>
    </div>

    <v-form ref="form" :url="exportUrl" :params="params" />
  </div>
</template>

<script>
import ItemOrderPick from './item-order-pick'
import ItemOrderRemark from './item-order-remark'
import FileUpload from '@/components/file-upload'
import ItemOrderList from './item-order-list'
import ItemOrderAddressList from './item-order-address-list'
import { commonUtils } from '@/utils/common'
import vForm from '@/components/v-form'
import { mapGetters } from 'vuex'
export default {
  name: 'ItemOrderTemplate',
  props: {
    hasBtn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ItemOrderPick,
    ItemOrderRemark,
    FileUpload,
    ItemOrderList,
    ItemOrderAddressList,
    vForm
  },
  data () {
    return {
      itemType: '',
      templateFile: null,
      hasImport: false,
      exportUrl: commonUtils.getApiUrl('/purchase/detail/convert-delivery'),
      params: {},
      orderForm: {
        // order-address
        deliveryList: [],
        // order-list
        detailList: [],
        purchaseOrder: {
          separateOrder: '0',
          orderType: '',
          detailFile: '',
          // order-pick
          quotaId: '',
          trKhCode: '',
          companyEntityId: '',
          costCenterId: '',
          // order-remark
          orderRemark: '',
          isUrgent: 0,
          purchaseOrg: 'CNY3',
          expectReceiveDate: '',
          orderDesc: '',
          sdCode: '',
          orgCode: ''
        }
      },
      isClear: false,
      isPrints: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      hasExport: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),

    hasCompany () {
      if (this.orderForm.purchaseOrder.companyEntityId) {
        return true
      } else {
        return false
      }
    },

    above () {
      if (!this.orderForm.detailList.length) {
        return
      }
      let flag = true
      this.orderForm.detailList.forEach(item => {
        if (item.purchaseQuantity < item.pocmDTO.factoryMOQ) {
          flag = false
        }
      })
      return flag
    }
  },
  watch: {
    hasExport (val) {
      if (val) {
        this.$refs.form.submit()
      }
    }
  },
  created () {
    if (this.$route.name === 'non-menu-template') {
      this.itemType = '03'
      this.templateFile = require('@/assets/files/import-non-menu-more-template.xlsx')
    } else if (this.$route.name === 'menu-list-template') {
      this.itemType = '01'
      this.templateFile = require('@/assets/files/import-menu-template.xlsx')
    } else {
      this.itemType = '02'
      this.templateFile = require('@/assets/files/import-prints-template.xlsx')
    }
    this.orderForm.purchaseOrder.orderType = this.itemType

    this.orderForm.purchaseOrder.sdCode = this.userInfo.orgDTO.sdCode
  },
  methods: {
    toFavourite () {
      this.$emit('toFavourite')
    },
    setValue (val) {
      this.orderForm.purchaseOrder.quotaId = val.quotaId
      this.orderForm.purchaseOrder.trKhCode = val.trKhCode
      this.orderForm.purchaseOrder.orgCode = val.orgCode
      this.orderForm.purchaseOrder.costCenterId = val.costCenterId
      // this.orderForm.purchaseOrder.purchaseOrg = val.purchaseOrg
    },
    setCompany (val) {
      this.orderForm.purchaseOrder.companyEntityId = val
    },

    // 获取订单描述
    setDesc (val) {
      this.orderForm.purchaseOrder.orderDesc = val
    },

    // 上传文件
    getDataFile (file) {
      this.isClear = false
      this.orderForm.purchaseOrder.detailFile = file.fileId
      this.importOrder()
    },

    // 订单交付数据导入
    importOrder () {
      let params = {
        dataFileId: this.orderForm.purchaseOrder.detailFile,
        generateDetail: 1,
        entityId: this.orderForm.purchaseOrder.companyEntityId
      }
      this.$store.dispatch('importOrder', params).then(res => {
        if (res.data.resultCode === '0') {
          this.isClear = false
          this.$message.success('物流发货明细上传成功')
          this.orderForm.deliveryList = res.data.resultData.deliveryList
          this.orderForm.detailList = res.data.resultData.detailList
          this.orderForm.detailList.forEach(item => {
            if (!item.pocmDTO.isPrints) {
              this.isPrints = true
            }
            this.$set(item, 'printsFiles', [])
            this.$set(item, 'printsFileUri', '')
            this.$set(item, 'detailRemark', '')
            this.$set(item, 'isProof', 0)
            this.$set(item, 'itemQuantity', item.purchaseQuantity)
            this.$set(item, 'subjectCategory', 'Z')
          })
          this.hasImport = true
          this.$store.commit('setIncrease', 1.06)
        } else {
          this.isClear = true
        }
      })
    },

    // 下载模板
    handleExport () {
      this.$store.dispatch('clearCartCache').then(res => {
        if (res.data.resultCode === '0') {
          this.hasExport++
          // this.$refs['form'].submit()
        }
      })
    },

    clearDataFile (file) {
      this.orderForm.purchaseOrder.detailFile = ''
      this.hasImport = false
      this.orderForm.deliveryList = []
      this.orderForm.detailList = []
    },

    setRemark (val) {
      this.orderForm.purchaseOrder.orderRemark = val
    },

    // 是否拆单
    getSeparateOrder (val) {
      this.orderForm.purchaseOrder.separateOrder = val ? '1' : '0'
    },

    // 订单验证
    checkSubmit () {
      if (
        !this.orderForm.purchaseOrder.quotaId &&
        !this.orderForm.purchaseOrder.trKhCode &&
        !this.orderForm.purchaseOrder.orgCode
      ) {
        this.$message.error('请选择预算')
        return false
      }
      if (!this.orderForm.purchaseOrder.companyEntityId) {
        this.$message.error('请选择工厂')
        return false
      }
      if (!this.orderForm.purchaseOrder.costCenterId) {
        this.$message.error('请输入成本中心Code并验证')
        return false
      }
      // if (!this.orderForm.purchaseOrder.purchaseOrg) {
      //   this.$message.error('请选择采购组织')
      //   return false
      // }
      if (!this.orderForm.deliveryList.length) {
        this.$message.error('请上传物流发货明细文档')
        return false
      }
      if (!this.orderForm.purchaseOrder.orderDesc) {
        this.$message.error('请输入订单描述')
        return false
      }
      if (!this.orderForm.purchaseOrder.expectReceiveDate) {
        this.$message.error('请选择期望收获日期')
        return false
      }
      return true
    },

    // 恢复printsFiles格式
    setPrintsFiles () {
      this.orderForm.detailList.forEach(item => {
        let arr = []
        if (typeof item.printsFiles === 'string') {
          arr = item.printsFiles.split(',')
          item.printsFiles = arr
        }
      })
    },

    // 提交订单
    handleSubmit () {
      if (!this.checkSubmit()) {
        return
      }
      this.orderForm.detailList.forEach(item => {
        let picFiles = ''
        this.$set(item, 'purchaseQuantity', item.itemQuantity)
        picFiles = item.printsFiles.join(',')
        item.printsFiles = picFiles
      })
      this.loading = true
      this.$store
        .dispatch('createOrder', this.orderForm)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$router.replace({
              path: '/material/item-order-success',
              query: { orderNumber: res.data.resultData.orderNumber }
            })
          }
          this.setPrintsFiles()
        })
        .catch(() => {
          this.loading = false
          this.$message.error('提交失败')
          this.setPrintsFiles()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-row {
  height: 36px;
  .feature-btn {
    float: right;
  }
}
.template-form-item {
  height: 100px;
  line-height: 100px;
  margin-top: 15px;
  .el-col-21 {
    height: 100%;
    display: flex;
    align-items: center;
    .btn-grey-plain {
      margin-right: 10px;
    }
  }
}
.primary-btn {
  margin-top: $page-middle;
  text-align: center;
  .el-button {
    width: 180px;
  }
}

// 是否拆单
::v-deep .el-checkbox {
  display: inline;

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2185d0;
    border-color: #2185d0;
  }
  .el-checkbox__inner:hover,
  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__input .el-checkbox__inner:focus {
    border-color: #2185d0;
  }
}
.intro {
  font-size: 11px;
  color: #2185d0;
  padding-left: 20px;
}
</style>
